import { motion } from "framer-motion"; // For modal entrance animations
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { Box, Typography, useMediaQuery } from "@mui/material";
import HtmlContent from "../../components/html-content/HtmlContent";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import { useTranslation } from "react-i18next";
import {
  AnimatedCounter,
  ConfettiTimed,
  ConfettiTimedMobile,
} from "./CelebrationCommon";
import WelcomeBackground from "../../assets/images/celebration-images/celeb_welcome_background.png";
import Ellipse from "../../assets/images/celebration-images/celeb_ellipse.png";

interface FirstLoginProps {
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}

export const FirstLogin: React.FC<FirstLoginProps> = ({
  onClose,
  celebration,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <motion.div
      className={`modal modal--first`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      {/* Confetti Effect */}

      {isMobile ? <ConfettiTimedMobile /> : <ConfettiTimed />}

      {/* Welcome Background Image */}
      <img
        src={WelcomeBackground}
        className="welcome-bg-image"
        alt="Welcome background"
      />
      <div className="circle-wrapper">
        <img src={Ellipse} className="circle-graphic" alt="Bonus circle" />
        <h2 className="counter-text">
          +<AnimatedCounter value={500} />
        </h2>
        <div className="counter-subtext">POINTS</div>
      </div>
      <Typography variant="body1" mb={3} className="celebration">
        <HtmlContent htmlString={celebration.content || "NA"} />
      </Typography>
      <Box sx={{ paddingBottom: "25px" }}>
        <CustomButton
          onClick={() => onClose(celebration)}
          variant="contained"
          text={t("noShowAppointment.closeButton")}
        />
      </Box>
    </motion.div>
  );
};
